import { FormattedMessage } from 'react-intl';
import { messages as sharedMessages } from '../messages';
import { messages } from './messages';

type ProviderDisplayNamePayload = {
  providerName: string;
  providerAppName?: string;
};

export const getInstructionsTitle = ({
  providerName,
  providerAppName,
}: ProviderDisplayNamePayload) => {
  if (providerAppName) {
    return <FormattedMessage {...messages.titleApp} values={{ providerAppName }} />;
  }

  return <FormattedMessage {...messages.title} values={{ providerName }} />;
};

type GetDefaultInstructionsPayload = {
  clientName: string | undefined;
  providerName: string;
};

export const getInstructions = ({ providerName, clientName }: GetDefaultInstructionsPayload) => {
  const isClientNameAbbreviated = clientName?.endsWith('.') ?? false;

  return [
    <FormattedMessage {...sharedMessages.step1} values={{ providerName }} />,
    <FormattedMessage {...messages.step2} />,
    <FormattedMessage
      {...messages.step3}
      values={{ clientName, isAbbreviated: isClientNameAbbreviated }}
    />,
  ];
};
